
module.exports = {
    baseURL : "https://api.ayroui.com"
    //  baseURL : "http://localhost:5000"
};

